import { Route, Routes } from "react-router-dom";
import { Header } from "./components/Header";
import { Home } from "./routes/Home";
import { Accuracy } from "./routes/Accuracy";
import { Pricing } from "./routes/Pricing";
import { Privacy } from "./routes/Privacy";
import { Terms } from "./routes/Terms";
import { Login } from "./routes/Login";
import { Traders } from "./routes/Traders";
import { Journalists } from "./routes/Journalists";
import { Researchers } from "./routes/Researchers";

export function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/traders" element={<Traders />} />
          <Route path="/journalists" element={<Journalists />} />
          <Route path="/researchers" element={<Researchers />} />
          <Route path="/accuracy" element={<Accuracy />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </main>
      <footer className="border-t border-ink/10 mt-12">
        <div className="max-w-5xl mx-auto px-6 py-6 text-sm text-ink/60 flex flex-wrap gap-4 justify-between">
          <span>© Eli Stowe — Chart to CSV</span>
          <nav className="flex gap-4">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms</a>
            <a href="/accuracy">Accuracy</a>
            <a href="mailto:support@chart-to-csv.com">Support</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
